(function ($, Cobalt, undefined) {
    var windowUnloading = false;
    var handleAjaxSuccess = function (e, xhr, settings) {
        var jsonResponse = undefined;
        try {
            jsonResponse = $.parseJSON(xhr.responseText);
        }
        catch (x) { jsonResponse = undefined; }
        if (jsonResponse !== undefined && jsonResponse !== null && jsonResponse.result === "AjaxRedirect") {
            document.location = jsonResponse.url;
        }
    };
    var handleAjaxError = function (e, xhr, settings) {
        if (windowUnloading) {
            // AJAX errors can occur on window unload, because the browser halts their execution.
            // Since the user doesn't care if an error occurs since they're leaving the page, no point in showing the dialog.
            return;
        }

        if (settings.mode === "abort" || xhr.status === 0) {
            // We don't care about requests that browsers might have aborted.
            return;
        }

        var title = 'Error';
        var message = 'We apologize but an unexpected error occured. <i>This is our fault, and the error has been logged</i>. If you want to report this to us include the following information:';
        var info = '';

        var statusCode = xhr.status;

        if (Cobalt.Constants.ActiveConfiguration == "production" && statusCode == 404) {
            return;
        }

        if (statusCode && xhr.statusText) {
            title = title + ' - ' + xhr.statusText;
        }

        if (statusCode) {
            info += 'HTTP Code: ' + statusCode + '\n';
        }

        if (xhr.statusText) {
            info += 'Status Text: ' + xhr.statusText + '\n';
        }

        info += 'Address: ' + location.href + '\n';
        info += 'Date: ' + new Date() + '\n';

        if (settings.url) {
            var type = settings.type || "GET";
            info += "Request: " + type + " " + settings.url + "\n";
        }

        $("<div/>")
            .append($("<div/>")
                .html(message)
                .css('padding-bottom', '1em'))
            .append($("<textarea/>")
                .val(info)
                .css('height', '150px'))
            .dialog({
                draggable: false,
                modal: true,
                title: title,
                resizable: false,
                dialogClass: "modal"
            })
            .parent()
            .center();
    };

    Cobalt.Core = {
        priority: 1,
        initialize: function () {
            Cobalt.Core.mapRoutes();
            Cobalt.Core.initializeContent();
        },
        initializeContent: function () {
            $(window).bind('beforeunload', function () {
                // this occurs when the user closes the page or somehow navigates away.
                windowUnloading = true;
            });

            // User Initialization            
            Cobalt.User.drawLanguageSelection();

            // ajax error handling
            $('body').ajaxError(handleAjaxError);

            $(document).on("ajaxSuccess", handleAjaxSuccess);

            // No Select
            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find('.no-select').disableSelection();
            });

            // Auto Select
            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find('input.auto-select').click(function () { this.select(); });
            });

            // Tooltips
            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find('.tip,.j-tooltip').tooltip();
            });
            
            // Add class to jquery dialog modals
            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find('.ui-dialog').addClass("p-modal-a");
            });

            $(window).delegate('body', 'click', Cobalt.Core.processDocumentClick);

            // Lightbox setup
            var lightboxSettings =
            {
                imageLoading: Cobalt.Constants.StaticURL + '/skins/global/images/lightbox/lightbox-ico-loading.gif',
                imageBtnPrev: Cobalt.Constants.StaticURL + '/skins/global/images/lightbox/lightbox-btn-prev.gif',
                imageBtnNext: Cobalt.Constants.StaticURL + '/skins/global/images/lightbox/lightbox-btn-next.gif',
                imageBtnClose: Cobalt.Constants.StaticURL + '/skins/global/images/lightbox/lightbox-btn-close.gif',
                imageBlank: Cobalt.Constants.StaticURL + '/skins/global/images/lightbox/lightbox-blank.gif'
            };

            // Nickname Credit
            var nicknameCreditCookieName = "NicknameCreditSite" + Cobalt.Constants.SiteID + "_User" + Cobalt.User.ID;
            var nicknameCreditCookie = $.cookie(nicknameCreditCookieName);
            var shouldShowNicknameModal = window.location.href.indexOf("twitch-merge") == -1 && window.location.href.indexOf("twitch-login") == -1;
            if (nicknameCreditCookie && shouldShowNicknameModal) {
                $.get("/change-nickname/" + nicknameCreditCookie + "/json", function (data) {
                    if (data) {
                        if (data.html) {
                            var $modal = $(data.html);

                            Cobalt.triggerHtmlInsert($modal);
                            $modal.dialog({
                                modal: true,
                                width: 500,
                                height: 320,
                                dialogClass: "p-change-nickname-modal",
                                closeOnEscape: false,
                                open: function () { $(".ui-dialog-titlebar").hide(); },
                                close: function (event, ui) {
                                    $modal.dialog("destroy");
                                    $modal.remove();
                                }
                            });

                            //form
                            var $form = $("#change-nickname-form");
                            
                            //find if a nickname cookie exists to prepopulate
                            var nicknameCookie = $.cookie("NicknameMerge" + Cobalt.Constants.SiteID);
                            if (nicknameCookie) {
                                $form.find("#field-new-username").val(nicknameCookie);
                            }
                            
                            $form.ajaxForm({
                                success: function (result) {
                                    if (result.status !== undefined && result.status !== "invalid") {
                                        $.cookie(nicknameCreditCookieName, null); //remove cookie
                                        $.cookie("NicknameMerge" + Cobalt.Constants.SiteID, null);
                                        if (result.nickname && result.nickname !== "") { //change name text
                                            $("ul.t-netbar-account a.t-netbar-label").text(" Welcome, " + result.nickname + "!");
                                            $("li.user span.user-name").text(result.nickname);
                                        }
                                        $modal.dialog('close');
                                    } else {
                                        if (result.errors) {
                                            Cobalt.Forms.displayErrors($form, result.errors);
                                        }
                                    }
                                }
                            });
                            //hook enter into submit button
                            $form.find("#field-new-username").on("keypress", function (e) {
                                if (e.which == 13 && $(this).val()) { //13 is enter
                                    $form.find("#field-submit").click();
                                }
                            });
                        }
                    }
                });
            }                        
            
            // Forum Filters
            if ($(".forum-topics-page-block").length > 0) {
                var forumFiltersCookie = $.cookie(Cobalt.ForumFilters.getCookieName(Cobalt.User.ID));
                if (forumFiltersCookie) { //has csv of forum ids
                    Cobalt.ForumFilters.updatePageBlock(forumFiltersCookie);
                }
            }

            Cobalt.runOnHtmlInsert(function ($parent) {
                $('a.lightbox').lightBox(lightboxSettings);
            });

            Cobalt.runOnHtmlInsert(function ($parent) {
                $(".j-gallery-post-widget").each(function (i, val) {
                    $(val).find(".gallery-lightbox").lightBox(lightboxSettings);
                });
                $parent.find(".j-gallery-post-widget").each(function (i, val) {
                    $(val).find(".gallery-lightbox").lightBox(lightboxSettings);
                });
            });

            var messageTypes = ['info', 'tip', 'success', 'warning', 'error', 'interstitial'];
            Cobalt.Core.processFlashMessages('FlashMessage', messageTypes);

            setInterval(function () {
                Cobalt.Core.processFlashMessages('FlashMessageAjax', messageTypes)
            }, 2500);

           

            $("body").delegate('.modal a.close', 'click', function () {
                var modal = $(this).parents('.modal');
                modal.hide();
                modal.trigger('hide');
                return false;
            });

            $("body").delegate('.flash-messages .message-close', 'click', function (e) {
                $(this).parents('.message').slideUp();
                e.preventDefault();
            });

            $("body").delegate('.flash-messages .message-no', 'click', function (e) {
                $(this).parents('.message').slideUp();
                e.preventDefault();
            });

            Cobalt.runOnHtmlInsert(function ($parent) {
                if (Cobalt.Constants != null && Cobalt.Constants.IgnoredUserIDs != null && Cobalt.Constants.IgnoredUserIDs.length == 0) {
                    return;
                }
                $.each(Cobalt.Constants.IgnoredUserIDs, function (i, val) {
                    if ($(".forum-threads").length > 0) {
                        $("[data-author-id=" + val + "]").find(".thread-author").append("<span class='ignoring-user'>(You are ignoring this user)</span>");
                        } else {
                            $("[data-author-id=" + val + "]").remove();
                    }
                });
            });

            // Audio gallery
            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find(".j-playlist-item").on("click", ".j-playlist-action", function () {
                    var $that = $(this);
                    var $mediaPlayer = $that.parents(".audio-gallery").find("audio.j-media-player");
                    if ($mediaPlayer.length > 0) {
                        $mediaPlayer.each(function () {
                            if ($(this).attr("src") === $that.data("url")) {
                                if ($that.hasClass("playing")) {
                                    this.player.pause();
                                }
                                else {
                                    this.player.play();
                                    $that.addClass("playing").find("i").removeClass("u-icon-play").addClass("u-icon-pause");
                                }
                            }
                            else {
                                this.player.pause();
                                this.player.setSrc($that.data("url"));
                                this.player.play();
                                $parent.find(".j-playlist-item .playing").removeClass("playing").find("i").removeClass("u-icon-pause").addClass("u-icon-play");
                                $that.addClass("playing").find("i").removeClass("u-icon-play").addClass("u-icon-pause");
                            }
                            this.addEventListener('ended', function () {
                                $that.removeClass("playing").find("i").removeClass("u-icon-pause").addClass("u-icon-play");
                            }, true);
                            this.addEventListener('pause', function () {
                                $that.removeClass("playing").find("i").removeClass("u-icon-pause").addClass("u-icon-play");
                            }, true);
                        });
                    }
                });
            });

            Cobalt.runOnHtmlInsert(function ($parent) {

                $parent.find('.expandable,.j-expandable').each(function () {

                    var $panel = $(this);
                    var $link;
                    var $persistCookieName;
                    var $button = $panel.attr("data-related-button");
                    var $arrow;

                    if ($button) {
                        $link = $panel.parent().find($button);
                        $persistCookieName = $link.attr('data-persist-cookie') || $panel.attr('data-persist-cookie');
                    }
                    if ($persistCookieName === undefined) {
                        $persistCookieName = $panel.attr('data-persist-cookie');
                    }
                    if ($panel.attr("processed") != "true") {
                        // Check if the element before the panel is an expandable link handler
                        if (!$link) {
                            if ($panel.prev().is('.expandable-link')) {
                                $link = $panel.prev();
                            } else { // Create our own handler
                                $link = $('<a class="expand-link" href="#">');
                            }
                            $panel.before($link);
                        }

                        if ($link.data("show-arrow") === true) {
                            $arrow = $('<a class="expand-link" href="#">');
                            $link.after($arrow);
                            $arrow.click(function (e) {
                                e.preventDefault();
                                $link.click();
                            });
                        }

                        var expandedByDefault = false;

                        if ($persistCookieName && $.cookie($persistCookieName)) {
                            expandedByDefault = $.cookie($persistCookieName) == "1";
                        }
                        else if ($panel.hasClass("expanded-by-default")) {
                            expandedByDefault = true;
                        }

                        if (expandedByDefault) {
                            $panel.removeClass('u-hidden').removeClass('hidden');
                            if ($link) {
                                $link.addClass("expanded");
                            }
                        } else if($panel.hasClass("expanded-by-default") && !expandedByDefault) {
                            $panel.hide();
                        }

                        Cobalt.Core.setExpandableLinkText($panel, $link);

                        $link.click(function (e) {
                            Cobalt.Core.handleExpandableClick($link, $panel, $persistCookieName, $arrow);
                            e.preventDefault();
                        });

                        $panel.attr("processed", "true");
                    }
                });
            });

            if ($.browser.msie === true && (+$.browser.version) < 9) {
                Cobalt.Core.handleIE();
            }

            // attach datepickers
            Cobalt.runOnHtmlInsert(function ($parent) {
                var datepickers = $parent.find('input[type=text].date');
                datepickers.datepicker({ changeMonth: true, changeYear: true, yearRange: '-100:+10' });
                datepickers.each(function (i, val) {
                    $(val).blur();
                });

                $parent.find('[data-date-time-watermark-format]').each(function () {
                    $(this).watermark($(this).attr("data-date-time-watermark-format"));
                });

                $parent.find('[data-date-time-mask-format]').each(function () {
                    $(this).mask($(this).attr("data-date-time-mask-format"));
                });

                $parent.find('.listing-client-side').each(function () {
                    $(this).grid({
                        pagerElements: undefined
                    });
                });

                $parent.find(".delete-prompt, .user-action-delete-prompt a").each(function () {
                    var $this = $(this);
                    Cobalt.Utils.setConfirmDelete($this);
                });

                $parent.find(".hidden-prompt").each(function () {
                    var $this = $(this);
                    Cobalt.Utils.setPromptHidden($this);
                });

                $parent.find("[data-prompt-message]").each(function () {
                    var $this = $(this);
                    Cobalt.Utils.setPrompt($this);
                });

                $parent.find('[data-ajax-load-url]').each(function () {
                    var $this = $(this);
                    var ajaxUrl = $this.attr('data-ajax-load-url');
                    var time = parseFloat($this.attr('data-ajax-load-time'));

                    if (!isFinite(time) || time < 0) {
                        time = 0;
                    }

                    setTimeout(function () {
                        $.get(ajaxUrl, function (html) {
                            $this.html(html);
                            Cobalt.triggerHtmlInsert($this);
                        });
                    }, time);
                });
            });

            // Bulk moderation
            Cobalt.BulkModeration.initialize();
            
            Cobalt.runOnHtmlInsert(function ($parent) {
                $parent.find('[data-user-only]').each(function () {
                    var $element = $(this);
                    var userID = $element.attr('data-user-only');
                    if (userID == Cobalt.User.userID && !$element.attr('data-ignore-user-only')) {
                        $element.removeAttr("data-user-only").show();
                    }
                });

                $parent.find('[data-user-except]').each(function () {
                    var $element = $(this);
                    var userID = $element.attr('data-user-except');
                    if (userID != Cobalt.User.userID) {
                        $element.removeAttr("data-user-except").show();
                    }
                });
            });

            // Page form visibility
            Cobalt.runOnHtmlInsert(function ($parent) {
                var formVisibilityFields = $parent.find("select.entity-protection, select.forum-visibility, select.page-visibility, select.post-visibility, select.category-visibility");

                if (formVisibilityFields.length > 0) {
                    formVisibilityFields.each(function (i, val) {
                        if ($(val).is("select")) {
                            Cobalt.Core.bindVisibilityField($(val));
                        }
                    });
                }
            });

            $('body').delegate('a.print', 'click', function () {
                window.print();
            });

            // jQuery dialog defaults
            $.extend($.ui.dialog.prototype.options, {
                modal: true,
                resizable: false,
                draggable: false
            });

            $(".report-translations a").click(function (e) {
                e.preventDefault();
                var queryStringObj = Cobalt.Utils.queryStringToObject();
                var queryString = "";
                if (!$(this).hasClass("cancel-reporting")) {
                    queryStringObj["report-translations"] = true;
                    queryString = Cobalt.Utils.objectToQueryString(queryStringObj);
                } else {
                    queryString = Cobalt.Utils.removeFromQueryString("report-translations");
                }
                window.location.search = queryString;
            });
        },

        bindVisibilityField: function (field) {

            var formVisibilityField = $(field);
            var formRoleRequiredDiv = formVisibilityField.parents("form").find(".entity-role-requirements, .forum-role-required, .page-role-required, .post-role-required, .category-role-required").parents(".form-field");

            formRoleRequiredDiv.hide();

            if (formVisibilityField.val() == 2) {
                formRoleRequiredDiv.show();
            }

            formVisibilityField.change(function () {
                var val = $(this).val();
                formRoleRequiredDiv.hide();
                if (val === "2") {
                    formRoleRequiredDiv.show();
                }
                else {
                    formRoleRequiredDiv.hide();
                }
            });
        },
        mapRoutes: function () {
            Cobalt.Rating.ratingsRoute = Cobalt.Routes.Instance.RatingGetUserRatings;
            Cobalt.AdminPanel.adminGetSubnamespacesRoute = Cobalt.Routes.Instance.CPGetSubNamespaces;
            Cobalt.AdminPanel.adminGetRouteNamesRoute = Cobalt.Routes.Instance.CPGetRoutesForController;

            Cobalt.Shoutbox.getNewCommentsRoute = Cobalt.Routes.Instance.ShoutboxGetNewComments;
            Cobalt.Shoutbox.deleteMessageRoute = Cobalt.Routes.Instance.ShoutboxDeleteMessage;
            Cobalt.Shoutbox.addMessageRoute = Cobalt.Routes.Instance.ShoutboxAddMessage;
            Cobalt.Shoutbox.showShoutboxRoute = Cobalt.Routes.Instance.ShoutboxGetShowShoutboxPreference;
            Cobalt.Shoutbox.saveShowShoutboxPreferenceRoute = Cobalt.Routes.Instance.ShoutboxSaveShowShoutboxPreference;

            Cobalt.Rating.ratingsRoute = Cobalt.Routes.Instance.RatingGetUserRatings;

            Cobalt.MultiFileUpload.deleteAttachmentRoute = Cobalt.Routes.Instance.AttachmentDeleteAttachment;
        },
        htmlDecode: function (value) {
            var newValue = value.replace(/\&amp;/g, '&');
            newValue = newValue.replace(/\&lt;/g, '<');
            newValue = newValue.replace(/\&gt;/g, '>');
            newValue = newValue.replace(/\&quot;/g, '"');
            newValue = newValue.replace(/\&#x27;/g, '\'');
            return newValue;
        },
        addFlashMessage: function (message, messageType, extraData) {
            var cookieName = "FlashMessage." + messageType;
            var cookieContent = JSON.stringify({ Message: message, Data: extraData });
            var splitDomain = document.domain.split('.');
            var currentDomain = '.' + splitDomain[1] + '.' + splitDomain[2];
            $.cookie(cookieName, cookieContent, { path: "/", domain: currentDomain });
        },
        processFlashMessages: function (prefix, messageTypes) {
            $(document).ready(function () {
                $.each(messageTypes, function (i, type) {
                    var cookieName = prefix + '.' + type;
                    var cookie = $.cookie(cookieName);
                    if (cookie) {
                        cookie = unescape(cookie).replace(/\+/g, " ");
                        var cookieValue = JSON.parse(cookie);
                        if (!cookieValue) {
                            return;
                        }
                        cookieValue.Message = Cobalt.Core.htmlDecode(cookieValue.Message);
                        var cookieDiv = $('<div>').addClass('message message-' + type + ' flash-message flash-message-' + type);
                        // If no flash messages container exists, make it
                        if ($(".flash-messages").length == 0) {
                            $("body").prepend($("<div class=\"flash-messages\"></div>"));
                        }

                        $(cookieDiv).text(cookieValue.Message);

                        // If Data has been set on the message, and that data includes Actions, render each as a button link
                        if (cookieValue.Data && cookieValue.Data.Actions) {
                            $.each(cookieValue.Data.Actions,
                                function (i, action) {
                                    // Only allow relative urls
                                    if (action.link && !(action.link.indexOf(':') > -1 || action.link.indexOf('//') > -1)) {
                                        var actionButton = $('<a>').addClass('button')
                                            .text(Cobalt.Core.htmlDecode(action.text));
                                        if (action.cssClass) {
                                            $(actionButton.addClass(action.cssClass));
                                        }
                                        $(actionButton).attr('href', action.link);
                                        $(cookieDiv).append(actionButton);
                                    }
                                });
                        }
                        $(cookieDiv).append($('<a href="#" class="message-close"></a>')).hide();
                        $(cookieDiv).appendTo($('.flash-messages')).slideDown();

                        var splitDomain = document.domain.split('.');
                        var currentDomain = '.' + splitDomain[1] + '.' + splitDomain[2];
                        $.removeCookie(cookieName, { domain: currentDomain, path: '/' });
                        if (type == 'success') {
                            setTimeout(function () {
                                cookieDiv.slideUp();
                            }, 5000);
                        }
                    }
                });
            });
        },
        processDocumentClick: function (event) {
            // if the label was clicked, just stop here and stop bubbling... webkit bug
            if ($(event.target).is('label[for=page]')) {
                return false;
            }

            // hide goto page div when clicked outside of
            var gotoPage = $('#goto-page');
            if ($('#goto-page:visible').length > 0 && !$(event.target).parents().andSelf().is('#goto-page')) {
                gotoPage.hide();
            }

            // hide forum tools
            var forumTools = $('#forum-tools');
            if (forumTools.length > 0 && !$(event.target).parents().andSelf().is('#forum-tools')) {
                forumTools.hide();
            }

            // hide time field selector
            var timeSelector = $(".time-selector");
            if (timeSelector.length > 0 && !$(event.target).parents().andSelf().is('.time-selector') && !$(event.target).parents().andSelf().is('input.date-time.time')) {
                timeSelector.hide();
            }

            var dateEvents = $(".date-events");
            if (dateEvents.length > 0 && !$(event.target).parents().andSelf().is(".date-events")) {
                dateEvents.hide();
            }
        },

        setExpandableLinkText: function ($panel, $link) {
            var text = text;

            if (!$link.hasClass("expanded")) {
                var showText = $link.attr('data-show-text');
                if (showText) {
                    text = showText;
                } else {
                    text = 'Show';
                }
            } else {
                var hideText = $link.attr('data-hide-text');
                if (hideText) {
                    text = hideText;
                } else {
                    text = 'Hide';
                }
            }
            $panel.removeClass("not-hidden");

            // If the link handler is a button, find the span inside of it
            if ($link.is('.button')) {
                $link.children('span').text(text);
            } else {
                $link.text(text);
            }
        },

        handleExpandableClick: function (link, panel, persistCookieName, arrow) {
            var $link = link;
            var $panel = panel;
            var $arrow = arrow;
            if (persistCookieName) {
                $.cookie(persistCookieName, $panel.is(':visible') ? 0 : 1, { path: '/', expires: 365 });
            }

            if (!$panel.is(':visible')) {
                $panel.removeClass("u-hidden").removeClass("hidden");
                $link.addClass("expanded");
                if ($arrow) {
                    $arrow.addClass("expanded");
                }
                $panel.slideDown('fast', function () {
                    Cobalt.Core.setExpandableLinkText($panel, $link);
                    $panel.addClass("expanded-panel");
                });
            } else {
                $link.removeClass("expanded");
                if ($arrow) {
                    $arrow.removeClass("expanded");
                }
                $panel.removeClass("expanded-panel");
                $panel.slideUp('fast', function () {
                    Cobalt.Core.setExpandableLinkText($panel, $link);

                });
            }

            Cobalt.Core.setExpandableLinkText($panel, $link);
        },

        handleIE: function () {
            (function ($, undefined) {
                var handleChange = function (e, label) {
                    var $input = $(this);
                    if ($input.is('input:checkbox')) {
                        var $label = label != undefined ? $(label) : $("label[for='" + $input.attr("id") + "']");
                        if ($input.is(":checked")) {
                            $label.addClass("check-checked").removeClass("check-unchecked");
                        } else {
                            $label.addClass("check-unchecked").removeClass("check-checked");
                        }
                    }
                };

                $("input:checkbox").live("change", handleChange);
                $("input:checkbox").each(function (i, val) {
                    var $input = $(val);
                    var $label = $("label[for='" + $input.attr("id") + "']");
                    if ($label.length > 0) {
                        $input.trigger("change", $label);
                    }
                });
                Cobalt.Forms.fixIEButtons();
            })(jQuery);
        },
        processPrivacyPolicy: function () {
            $(document).ready(function() {
                var cookieName = 'Auth.PrivacyPolicy.Signed';
                var cookie = $.cookie(cookieName);
                var lastUpdate = parseInt(Cobalt.Constants.PrivacyPolicyLastUpdated);
                if (lastUpdate > 0 && (!cookie || lastUpdate > parseInt(cookie)) && ($(".privacy-policy-change").length == 0)) {
                    $.get(Cobalt.Routes.Instance.AuthenticationPrivacyPolicyJson(),
                         function (data) {

                             var splitDomain = document.domain.split('.');
                             var currentDomain = '.' + splitDomain[1] + '.' + splitDomain[2];

                             if (data.result == 'unsigned') {
                                 $("body").prepend($('<div class="privacy-policy-change"></div>'));
                                 var policyDiv = $('<div>').addClass('policy-message');
                                 $(policyDiv).html(data.html).appendTo($('.privacy-policy-change')).slideDown();

                                 $('[data-action="accept-policy-change"]').click(function(e) {
                                     $(this).parents('.privacy-policy-change').slideUp();
                                     $.get(Cobalt.Routes.Instance.AuthenticationPrivacyPolicySignedJson(), function (data) {
                                         if (data.result == 'success') {
                                             $.cookie(cookieName, data.date, { domain: currentDomain, path: '/', expires: 365 });
                                         } else {
                                             $.cookie(cookieName, data.date, { domain: currentDomain, path: '/', expires: 30 });
                                         }
                                     });
                                      
                                     e.preventDefault();
                                 });
                             }else if (data.result == 'signed') {
                                 $.cookie(cookieName, data.date, { domain: currentDomain, path: '/', expires: 365 });
                             }
                         }
                    );
                           
                }
            });
        },
        withRequestVerificationToken: function (callback) {
            var token = $.cookie("RequestVerificationToken");
            if (token) {
                callback(token);
                return;
            }

            $.ajax({
                url: "/refresh-request-verification-token",
                type: 'POST',
                dataType: 'json',
                async: false,
                success: function (data) {
                    token = $.cookie("RequestVerificationToken");
                    callback(token);
                }
            });
        }       
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Core.js